import { render } from "./passConfig.vue?vue&type=template&id=6d6d16bf"
import script from "./passConfig.vue?vue&type=script&lang=js"
export * from "./passConfig.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/passApply/passConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d6d16bf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d6d16bf', __exports__)) {
    console.log('reload')
    api.reload('6d6d16bf', __exports__)
  }
  
  module.hot.accept("./passConfig.vue?vue&type=template&id=6d6d16bf", () => {
    console.log('re-render')
    api.rerender('6d6d16bf', render)
  })

}


export default __exports__